<template>
<div>
    <router-view name="header-vertical"></router-view>
<!-- <router-view name="search-header" />-->
    <router-view></router-view>
    <router-view
        name="side-menu"
        data-cy="sideMenu"
    >
    </router-view>

    <div>
            <FailureModal
                    v-if="popUpFailure==true"
                    :failureText="failureMessage"
                    class="failure-modal"
                    @close="popUpFailure = false"
            />
    </div>
</div>
</template>

<script>
import Header from '@Common/Header.vue'
import VerticalHeader from '@Common/VerticalHeader.vue'
import SideMenu from '@Common/SideMenu.vue'
import { axiosRequests } from './main.js'
import FailureModal from '@Common/modals/FailureModal.vue'

export default {
    data() {
        return { 
            authenticated: false,
            securityProfile: process.env.SECURITY_PROFILE.split(","),
            popUpFailure: false,
            failureMessage: ""
        }
    },
    created () { 
        if(this.securityProfile.includes('security-okta')){
            this.setup()
            this.$auth.authStateManager.subscribe(this.isAuthenticated)
        }
        else if(this.securityProfile.includes('security-db')){
            const token = localStorage.getItem("token")
            axiosRequests.defaults.headers.authorization = token
            
            axiosRequests.get().then((resp)=>{
                if(resp.status == 200){
                    this.$store.dispatch('loginFromToken', { token })
                }
            }).catch(() =>{
                    this.$store.dispatch('logout')
                    this.$store.dispatch('setSystemMessage', {message: "You have been logged out. Please enter your credentials."})
                }
            )

        } 
        //security-off profile default behaviour
        else {
            // TODO: Use webpack to strip this code block in production
            axiosRequests.get().then(
            (resp)=>{
                    // If authorization header is empty and resp is 200, security-off profile is active
                    if(resp.status == 200){
                        const token = "STUB-JWT.eyJzdWIiOiIwIiwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhvcml0aWVzIjpbIlJPTEVfQURNSU4iLCJSRUFEIiwiQ1JFQVRFIiwiREVMRVRFIiwiVVBEQVRFIl19.UNSIGNED"
                        this.$store.dispatch('loginFromTokenWithoutBearer', { 'token': token })
                    }
            }
            ).catch(
                () => this.$store.dispatch('logout')
            )
        }
    },
    watch: {
        // Everytime the route changes, check for auth status
        '$route' (to, from) {
            document.title = to.name || 'Jarvis'
        }
    },
    methods: {
        async isAuthenticated () {
            this.authenticated = await this.$auth.isAuthenticated()
            return this.authenticated
        },
        async setup(){
            var isAuthenticated = await this.isAuthenticated()
            
            if(isAuthenticated){
                
                const token = await this.$auth.tokenManager.getTokens()
                const claims = await this.$auth.getUser(token.accessToken)
                
                this.$store.dispatch('loginFromOktaToken',{'token': token.accessToken.value,
                    'parsedToken': token.accessToken,  'claims':claims})
            }
        },
        async checkDbStatus() {
              var isAuthenticated = await this.isAuthenticated()
              if(isAuthenticated){
                  try {
                   axiosRequests.get('/db-status')
                     .then(response => {
                       if (response.data.status !== "UP") {
                         this.popUpFailure = true;
                         this.failureMessage = "Database is Down. Kindly try after sometime. \
                         If the issue persists, kindly contact support at IT@blbglaw.com";
                       }
                     })
                     .catch(error => {
                       // Optional: log the error for debugging
                       console.error("Error fetching /db-status:");
                     });
                  } catch (error) {
                    this.popUpFailure=true;
                    this.failureMessage = "Jarvis is Down. kindly contact support at IT@blbglaw.com"
                  }
              }
        }
    },
    components: {
        appHeader: Header,
        sideMenu: SideMenu,
        verticalHeader: VerticalHeader,
        FailureModal
    },
    mounted() {
        this.checkDbStatus();

        // Set interval for periodic checks (every 10 minutes)
        this.checkIntervalId = setInterval(this.checkDbStatus, 600000);
      },
      beforeUnmount() {
        // Clean up the interval when component is destroyed (Vue 3)
        clearInterval(this.checkIntervalId);
      }
}
</script>

// Load external CSS Blocks
<style src="vue-simple-calendar/static/css/default.css"></style>
<style src="vue-simple-calendar/static/css/holidays-us.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

// Load CKM Theme files
<style src="@Style/ckm-style/stylesheets/fonts.css"></style>
<style src="@Style/ckm-style/stylesheets/main.css"></style>
<style src="@Style/header.css"></style>
<style src="@Style/sideMenu.css"></style>
<style src="@Style/visualizationContainer.css"></style>

// Load custom App Theme files
<style src="@Style/grid.css"></style>
<style src="@Style/index.css"></style>
<style lang="scss" src="@Style/_index.scss"></style>